import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type LeaveGuardStoreType = {
  hasUnsavedChanges: boolean
  isNestedAttachmentAdded: boolean
  setHasUnsavedChanges: (hasChanges: boolean) => void
  setIsNestedAttachmentAdded: (isAdded: boolean) => void
}

export const useLeaveGuardStore = create<LeaveGuardStoreType>()(
  devtools(
    set => ({
      hasUnsavedChanges: false,
      isNestedAttachmentAdded: false,
      setHasUnsavedChanges: (hasChanges: boolean) =>
        set({ hasUnsavedChanges: hasChanges }),
      setIsNestedAttachmentAdded: (isAdded: boolean) =>
        set({ isNestedAttachmentAdded: isAdded })
    }),
    { name: 'LeaveGuardStore' }
  )
)
